module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("\n    ASD\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ad8275a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/avatarLoader.vue
// module id = 2232
// module chunks = 0